import { Button, Typography } from 'omakase';
import { Grid } from 'ui';
import { IconPlusLarge } from '@tock/icons';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router';
import { StoreType, useActions } from '@tock/shared/utils/connect';
import { useMountEffect } from '@tock/hooks';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { yourListsTitle } from 'routes/protected/accountPlaylistsRouteCssDefs';
import CreatePlaylistDialog from 'components/profile/playlists/CreatePlaylistDialog';
import ProfilePlaylistDetailsRoute from './profile/ProfilePlaylistDetailsRoute';
import ProfilePlaylistsList from 'components/profile/playlists/ProfilePlaylistsList';
import useLoadPlaylists from 'hooks/useLoadPlaylists';

const AccountPlaylistsRoute: React.FunctionComponent = () => {
  const { actions } = useActions();
  const match = useRouteMatch();
  useLoadPlaylists();

  const { playlists, navigation } = useSelector((state: StoreType) => ({
    playlists: state.patron.playlists.data,
    navigation: state.navigation,
  }));
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const history = useHistory();
  const handleDeletePlaylistDone = () => {
    history.replace(match.path);
  };

  useMountEffect(() => {
    actions.navigation.set({ title: 'Saved', hasBack: true });
    return () => {
      actions.navigation.set(navigation);
    };
  });

  return (
    <Switch>
      <Route path={`${match.path}`} exact>
        <>
          <Grid container justify="space-between" css={yourListsTitle}>
            <Grid item>
              <Typography component="h5" variant="heading03">
                Your lists
              </Typography>
            </Grid>
            <Grid item>
              <Button
                iconStart={<IconPlusLarge />}
                variant="ghost"
                size="medium"
                onClick={() => setIsCreateDialogOpen(true)}
              >
                New list
              </Button>
            </Grid>
          </Grid>
          <div>
            <ProfilePlaylistsList playlists={playlists || []} />
          </div>
          <CreatePlaylistDialog
            isOpen={isCreateDialogOpen}
            onClose={() => setIsCreateDialogOpen(false)}
          />
        </>
      </Route>
      <Route path={`${match.path}/:playlistId`}>
        <ProfilePlaylistDetailsRoute onDeletePlaylistDone={handleDeletePlaylistDone} />
      </Route>
    </Switch>
  );
};

// todo recently saved playlists ribbon

// interface RecentlySavedPlaylistItemsProps {
//   playlistItemDetails: PlaylistItemWithPlaylist[];
// }

// interface PlaylistItemWithPlaylist {
//   playlistItem: consumer.PlaylistItem;
//   playlistDescriptor: PlaylistDescriptor;
// }

// const RecentlySavedPlaylistItems: React.FunctionComponent<> = () => {};

export default AccountPlaylistsRoute;
